<template>
  <div>
    <RouterView />
  </div>
</template>

<script setup lang="ts"></script>
